import { Checkbox } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import useMonths from 'src/Hooks/CalendarLogic/useMonths';
import { TransformValues } from 'src/types/transform-values.type';
import getNestedValue from 'src/Utils/getNestedValue';

import styles from './EventCreationMonthPicker.module.scss';
import { Props } from './EventCreationMonthPicker.types';

const EventCreationMonthPicker = <T, O extends TransformValues<T>>({
  form,
  pathMonthValue = 'recurrence.byMonth',
}: Props<T, O>) => {
  const { t } = useTranslation();
  const months = useMonths();

  const monthValue = getNestedValue(form.values, pathMonthValue) || [];

  return (
    <div className={styles.container}>
      <div className={styles.label}>{t('createEventForm.customInMonth', 'En')}</div>
      <div className={styles.month}>
        {months.map(month => {
          const toggleMonth = (checked?: boolean) => {
            const isCurrentlySelected = checked ?? monthValue.includes(month.index);

            const newMonths = !isCurrentlySelected
              ? [...monthValue, month.index]
              : monthValue.filter((m: number) => m !== month.index);

            form.setFieldValue(pathMonthValue, newMonths);
          };

          return (
            <Checkbox
              key={month.fullName}
              label={month.shortName}
              className={styles.checkbox}
              checked={monthValue.includes(month.index)}
              onChange={event => toggleMonth(event.currentTarget.checked)}
              wrapperProps={{
                onClick: () => toggleMonth(),
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default EventCreationMonthPicker;
